import { defineComponent as _defineComponent } from 'vue'
import { computed, useStore } from '@nuxtjs/composition-api';
import type { IPost } from '@/types/community';
import { buildCommentUrl, prepareCommentText } from '~/components/partials/war-room/WarRoomExposedComments/utils';
import type { RootState } from '~/types/store';

type WarRoomSchemaProps = {
  post: IPost;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'WarRoomSchema',
  props: {
    post: null
  },
  setup(__props: any) {

const props = __props as {
  post: IPost;
};


const store = useStore<RootState>();

const commentTree = computed(() => store.state.warRoom.commentTree);

/**
 * Create JSON-ld QAPage scheme #GROW-37
 * https://developers.google.com/search/docs/appearance/structured-data/qapage
 */
const json = computed(() => {
  if (!commentTree.value || !commentTree.value.length) return {};

  const answers = commentTree.value.filter(({ rating, text }) => rating > 0 && !!text);

  // Don't render schema if we don't have any answers
  if (!answers.length) return {};

  const [topAnswer, ...restAnswers] = answers
    .map(comment => ({
      '@type': 'Answer',
      text: prepareCommentText(comment.text),
      upvoteCount: comment.rating,
      url: buildCommentUrl(props.post.slug, comment.id, true),
    }))
    .sort((a, b) => b.upvoteCount - a.upvoteCount);

  return JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'QAPage',
    mainEntity: {
      '@type': 'Question',
      name: props.post.content.data.title,
      text: props.post.content.data.text,
      answerCount: props.post.comment_count?.total,
      upvoteCount: props.post.rating,
      acceptedAnswer: topAnswer,
      suggestedAnswer: restAnswers,
    },
  });
});

return { __sfc: true,props, store, commentTree, json }
}

})